import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the table menu view.
 * @extends JetView
 */
export default class tableMenuView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this; // Reference to the current instance
        var url = devConfig.geturlApi() + 'UserManagement/GetMenusUserReports'; // API endpoint for fetching user reports
        var filter = ''; // Filter string for data fetching
        var country = ''; // Selected country for filtering
        const id_partner = this.getParam('partner', true); // Partner ID from parameters

        // Event listener for table filtering
        this.on(this.app, 'filter:table', (data) => {
            filter = data; // Update filter with received data
        });

        // Event listener for menu filtering
        this.on(this.app, 'menu:filter', (filterData) => {
            country = filterData.Country; // Update country with received filter data
        });

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Treetable component for displaying menu data
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                $group: {
                                    by: 'MENU_TITLE', // Grouping by menu title
                                    map: {
                                        SUBMENU_ID: ['MENU_ID'], // Mapping submenu ID
                                        SUBMENU_URL: ['MENU_SLUG'], // Mapping submenu URL
                                        SUBMENU_TITLE: ['MENU_TITLE'], // Mapping submenu title
                                    },
                                },
                            },
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'MENU_TITLE', // Column ID for menu title
                                    header:
                                        _('Menú') +
                                        "<span class='webix_icon wxi-close reply' style='margin-left: 10px'></span>", // Header with icon
                                    width: 200,
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            // Check if the row is a group
                                            return common.treetable(obj, common) + obj.value;
                                        return obj.MENU_TITLE; // Return menu title
                                    },
                                },
                                {
                                    id: 'rating', // Column ID for actions
                                    header: '',
                                    width: 80,
                                    height: 25,
                                    template: function (obj) {
                                        if (obj.$level == 1) {
                                            // Check if the level is 1
                                            return "<span class='webix_icon wxi-close edit'></span><span class='webix_icon wxi-close torefuse'></span><span class='webix_icon wxi-close reply'></span>";
                                        } else {
                                            return "<span class='webix_icon wxi-close edit'></span><span class='webix_icon wxi-close torefuse'></span>";
                                        }
                                    },
                                },
                                {
                                    id: 'SUBMENU_ID', // Column ID for submenu ID
                                    header: 'Id', // Column header
                                    width: 50,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SUBMENU_URL', // Column ID for submenu URL
                                    header: _('Url'), // Column header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SUBMENU_TITLE', // Column ID for submenu title
                                    header: _('Descripción'), // Column header
                                    width: 250,
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger openEdit event
                                },
                                reply: function (euv, id) {
                                    // Event handler for reply button click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('createMenu:button', [
                                        item, // Trigger createMenu event with item data
                                    ]);
                                },
                                torefuse: function (euv, id) {
                                    // Event handler for refuse button click
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning', // Confirmation type
                                        text: _('Advertencia!') + '<br/>' + _('Desea eliminar menú?'), // Confirmation message
                                        ok: _('Aceptar'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            if (action === true) {
                                                // If confirmed
                                                var item = vvthis.getItem(id); // Get the item to delete
                                                const params = {
                                                    Partner: id_partner, // Partner ID
                                                    Country: country, // Selected country
                                                    SUBMENU_ID: item.SUBMENU_ID, // Submenu ID
                                                };
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'UserManagement/DeleteMenusUser',
                                                        params, // Send parameters
                                                        {
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var resp = JSON.parse(
                                                                    text, // Parse response
                                                                );
                                                                if (
                                                                    resp.HasError // Check for errors
                                                                ) {
                                                                    webix.message(
                                                                        _(
                                                                            'Menú Eliminado', // Show success message
                                                                        ),
                                                                    );
                                                                    $$('datatable').clearAll(); // Clear datatable
                                                                    $$('datatable')
                                                                        .load(
                                                                            url + '?start=0&count=1000' + filter, // Reload data
                                                                        )
                                                                        .then((response) => {
                                                                            var json = response.json(); // Parse response
                                                                            if (
                                                                                !json.HasError // Check for errors
                                                                            ) {
                                                                                const data = [];
                                                                                json.Data.forEach(function (menu) {
                                                                                    menu.SUBMENUS.forEach(
                                                                                        function (submenu, index) {
                                                                                            var obj = {
                                                                                                SUBMENU_ID:
                                                                                                    submenu.SUBMENU_ID,
                                                                                                SUBMENU_URL:
                                                                                                    submenu.SUBMENU_URL,
                                                                                                SUBMENU_TITLE:
                                                                                                    submenu.SUBMENU_TITLE,
                                                                                                MENU_ID: menu.MENU_ID,
                                                                                                MENU_TITLE:
                                                                                                    menu.MENU_TITLE,
                                                                                                MENU_SLUG:
                                                                                                    menu.MENU_SLUG,
                                                                                            };
                                                                                            data.push(
                                                                                                obj, // Push submenu data to array
                                                                                            );
                                                                                        },
                                                                                    );
                                                                                });
                                                                                $$('datatable').clearAll(); // Clear datatable
                                                                                $$('datatable').parse(
                                                                                    data, // Parse new data
                                                                                );
                                                                            } else {
                                                                                $$('datatable').clearAll(); // Clear datatable on error
                                                                            }
                                                                        });
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the datatable
        const _ = this.app.getService('locale')._;
        var url = devConfig.geturlApi() + 'UserManagement/GetMenusUserReports'; // API endpoint for fetching user reports
        const id_partner = this.getParam('partner', true); // Partner ID from parameters
        var optionsMenusFather = [
            {
                id: '0',
                value: _('Ninguno'), // Default option for parent menu
            },
        ];
        var popupAdd; // Popup for adding a new menu
        var popupEdit; // Popup for editing a menu
        var country = ''; // Selected country for filtering

        // Event listener for menu filtering
        this.on(this.app, 'menu:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filtering
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Build query string
                    if (object[i][0] == 'Country') {
                        country = object[i][1]; // Update country
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=1000' + string1).then((response) => {
                var json = response.json(); // Parse response
                if (!json.HasError) {
                    // Check for errors
                    const data = []; // Array to hold menu data
                    json.Data.forEach(function (menu) {
                        var objFather = {
                            id: menu.MENU_ID,
                            value: menu.MENU_TITLE, // Create object for parent menu
                        };
                        optionsMenusFather.push(objFather); // Add parent menu to options
                        menu.SUBMENUS.forEach(function (submenu, index) {
                            var obj = {
                                SUBMENU_ID: submenu.SUBMENU_ID,
                                SUBMENU_URL: submenu.SUBMENU_URL,
                                SUBMENU_TITLE: submenu.SUBMENU_TITLE,
                                MENU_ID: menu.MENU_ID,
                                MENU_TITLE: menu.MENU_TITLE,
                                MENU_SLUG: menu.MENU_SLUG,
                            };
                            data.push(obj); // Push submenu data to array
                        });
                    });
                    popupAdd = webix.ui({
                        view: 'window', // Create popup window for adding menu
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Crear Menú') }, // Popup title
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide(); // Close popup
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: true, // Modal popup
                        body: {
                            view: 'form', // Form for menu creation
                            id: 'createMenuForm', // Form ID
                            elements: [
                                {
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Url'), // URL field
                                            name: 'SUBMENU_URL',
                                            required: true, // Required field
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Descripción'), // Description field
                                            name: 'SUBMENU_TITLE',
                                            required: true, // Required field
                                        },
                                        {
                                            view: 'combo',
                                            id: 'MENU_ID', // Combo for parent menu selection
                                            labelPosition: 'top',
                                            label: _('Menú Padre'),
                                            name: 'MENU_ID',
                                            options: optionsMenusFather, // Options for parent menus
                                            readonly: true, // Readonly field
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'), // Cancel button
                                            click: function () {
                                                this.getTopParentView().hide(); // Close popup
                                                $$('createMenuForm').setValues(
                                                    $$('createMenuForm').getCleanValues(), // Reset form values
                                                );
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'), // Save button
                                            click: function ($e) {
                                                var values = $$('createMenuForm').getValues(); // Get form values
                                                if (
                                                    $$('createMenuForm').validate() // Validate form
                                                ) {
                                                    values.Partner = id_partner; // Add partner ID
                                                    values.Country = country; // Add country
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'UserManagement/CreateMenuUser',
                                                            values, // Send form values
                                                            {
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    text = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (
                                                                        !text.HasError // Check for errors
                                                                    ) {
                                                                        webix.message(
                                                                            'Menú creado satisfactoriamente', // Show success message
                                                                        );
                                                                        grid.clearAll(); // Clear grid
                                                                        grid.load(
                                                                            url + '?start=0&count=1000' + string1, // Reload data
                                                                        ).then((response) => {
                                                                            var json = response.json(); // Parse response
                                                                            if (
                                                                                !json.HasError // Check for errors
                                                                            ) {
                                                                                const data = [];
                                                                                optionsMenusFather = []; // Reset parent menu options
                                                                                json.Data.forEach(function (menu) {
                                                                                    var objFather = {
                                                                                        id: menu.MENU_ID,
                                                                                        value: menu.MENU_TITLE, // Create object for parent menu
                                                                                    };
                                                                                    optionsMenusFather.push(
                                                                                        objFather, // Add parent menu to options
                                                                                    );
                                                                                    menu.SUBMENUS.forEach(
                                                                                        function (submenu, index) {
                                                                                            var obj = {
                                                                                                SUBMENU_ID:
                                                                                                    submenu.SUBMENU_ID,
                                                                                                SUBMENU_URL:
                                                                                                    submenu.SUBMENU_URL,
                                                                                                SUBMENU_TITLE:
                                                                                                    submenu.SUBMENU_TITLE,
                                                                                                MENU_ID: menu.MENU_ID,
                                                                                                MENU_TITLE:
                                                                                                    menu.MENU_TITLE,
                                                                                                MENU_SLUG:
                                                                                                    menu.MENU_SLUG,
                                                                                            };
                                                                                            data.push(
                                                                                                obj, // Push submenu data to array
                                                                                            );
                                                                                        },
                                                                                    );
                                                                                });
                                                                                grid.clearAll(); // Clear grid
                                                                                grid.parse(
                                                                                    data, // Parse new data
                                                                                );
                                                                            } else {
                                                                                grid.clearAll(); // Clear grid on error
                                                                            }
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                        );
                                                    this.getTopParentView().hide(); // Close popup
                                                } else {
                                                    webix.message({
                                                        title: _('¡Error!'), // Error message title
                                                        type: 'alert-error',
                                                        text: _(
                                                            'Completa los campos...', // Error message text
                                                        ),
                                                    });
                                                }
                                            },
                                        },
                                    ],
                                },
                            ],
                            elementsConfig: {
                                on: {
                                    onChange: function () {
                                        this.validate(); // Validate form on change
                                    },
                                },
                            },
                        },
                    });
                    popupEdit = webix.ui({
                        view: 'window', // Create popup window for editing menu
                        id: 'editMenu', // Popup ID
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Editar Menú') }, // Popup title
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide(); // Close popup
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: true, // Modal popup
                        body: {
                            view: 'form', // Form for menu editing
                            id: 'editform', // Form ID
                            elements: [
                                {
                                    margin: 10,
                                    rows: [
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Id'), // ID field
                                            name: 'SUBMENU_ID',
                                            readonly: true, // Readonly field
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Url'), // URL field
                                            name: 'SUBMENU_URL',
                                            readonly: false, // Editable field
                                        },
                                        {
                                            view: 'text',
                                            labelPosition: 'top',
                                            label: _('Descripción'), // Description field
                                            name: 'SUBMENU_TITLE',
                                            readonly: false, // Editable field
                                        },
                                        {
                                            view: 'combo',
                                            labelPosition: 'top',
                                            label: _('Menú Padre'), // Parent menu selection
                                            name: 'MENU_ID',
                                            options: optionsMenusFather, // Options for parent menus
                                            readonly: false, // Editable field
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'), // Cancel button
                                            click: function () {
                                                this.getTopParentView().hide(); // Close popup
                                                $$('editform').setValues(
                                                    $$('editform').getCleanValues(), // Reset form values
                                                );
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'), // Save button
                                            click: function ($e) {
                                                var values = $$('editform').getValues(); // Get form values
                                                if (
                                                    $$('editform').validate() // Validate form
                                                ) {
                                                    const params = {
                                                        Partner: id_partner, // Partner ID
                                                        Country: country, // Selected country
                                                        SUBMENU_ID: values.SUBMENU_ID, // Submenu ID
                                                        SUBMENU_URL: values.SUBMENU_URL, // Submenu URL
                                                        SUBMENU_TITLE: values.SUBMENU_TITLE, // Submenu title
                                                        MENU_ID: values.MENU_ID, // Parent menu ID
                                                    };
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'UserManagement/EditMenuUser',
                                                            params, // Send parameters
                                                            {
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    text = JSON.parse(
                                                                        text, // Parse response
                                                                    );
                                                                    if (
                                                                        !text.HasError // Check for errors
                                                                    ) {
                                                                        webix.message(
                                                                            'Menú editado satisfactoriamente', // Show success message
                                                                        );
                                                                        grid.clearAll(); // Clear grid
                                                                        grid.load(
                                                                            url + '?start=0&count=1000' + string1, // Reload data
                                                                        ).then((response) => {
                                                                            var json = response.json(); // Parse response
                                                                            if (
                                                                                !json.HasError // Check for errors
                                                                            ) {
                                                                                const data = [];
                                                                                optionsMenusFather = []; // Reset parent menu options
                                                                                json.Data.forEach(function (menu) {
                                                                                    var objFather = {
                                                                                        id: menu.MENU_ID,
                                                                                        value: menu.MENU_TITLE, // Create object for parent menu
                                                                                    };
                                                                                    optionsMenusFather.push(
                                                                                        objFather, // Add parent menu to options
                                                                                    );
                                                                                    menu.SUBMENUS.forEach(
                                                                                        function (submenu, index) {
                                                                                            var obj = {
                                                                                                SUBMENU_ID:
                                                                                                    submenu.SUBMENU_ID,
                                                                                                SUBMENU_URL:
                                                                                                    submenu.SUBMENU_URL,
                                                                                                SUBMENU_TITLE:
                                                                                                    submenu.SUBMENU_TITLE,
                                                                                                MENU_ID: menu.MENU_ID,
                                                                                                MENU_TITLE:
                                                                                                    menu.MENU_TITLE,
                                                                                                MENU_SLUG:
                                                                                                    menu.MENU_SLUG,
                                                                                            };
                                                                                            data.push(
                                                                                                obj, // Push submenu data to array
                                                                                            );
                                                                                        },
                                                                                    );
                                                                                });
                                                                                grid.clearAll(); // Clear grid
                                                                                grid.parse(
                                                                                    data, // Parse new data
                                                                                );
                                                                            } else {
                                                                                grid.clearAll(); // Clear grid on error
                                                                            }
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                        );
                                                    this.getTopParentView().hide(); // Close popup
                                                } else {
                                                    webix.message({
                                                        title: _('¡Error!'), // Error message title
                                                        type: 'alert-error',
                                                        text: _(
                                                            'Completa los campos...', // Error message text
                                                        ),
                                                    });
                                                }
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });
                    $$('editform').bind($$('datatable')); // Bind edit form to datatable
                    grid.clearAll(); // Clear grid
                    grid.parse(data); // Parse new data into grid
                    this.app.callEvent('filter:table', [string1]); // Trigger filter event
                }
            });
        });

        // Event listener for creating a new menu
        this.on(this.app, 'createMenu:button', (filter) => {
            if (optionsMenusFather.length > 1) {
                // Check if there are parent menus available
                popupAdd.show(); // Show add menu popup
                $$('createMenuForm').clearValidation(); // Clear form validation
                if (filter != undefined) {
                    $$('MENU_ID').setValue(filter.SUBMENU_ID); // Set value for parent menu if filter is provided
                } else {
                    $$('MENU_ID').setValue('0'); // Default value for parent menu
                }
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message if no data is loaded
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Error message type
                });
            }
        });

        // Event listener for opening the edit menu popup
        this.on(this.app, 'openEdit', (item) => {
            popupEdit.show(); // Show edit menu popup
        });
    }
}

// FILE DOCUMENTED
